// 🔧 sponsor_repository.js
// ✅ Purpose: Persists Sponsor Engine data to Firestore
// ✅ Features:
// - Saves Sponsor Levels
// - Saves Sponsors
// - Centralizes all Firestore writes
// - Future-ready for updates, deletes, and reconciliation
// - Fully block-commented for clarity and future devs

import {
  collection,
  doc,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../../../firebase";

/**
 * Saves Sponsor Levels.
 */
export const saveSponsorLevels = async ({
  demoContext,
  sponsorLevels = [],
} = {}) => {
  const eventId =
    demoContext?.eventResult?.eventId;

  if (!eventId || sponsorLevels.length === 0) {
    return;
  }

  const batch = writeBatch(db);

  sponsorLevels.forEach((level) => {
    const ref = doc(
      collection(
        db,
        "events",
        eventId,
        "sponsorLevels"
      )
    );

    batch.set(ref, {
      ...level,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      demoSeed: true,
    });
  });

  await batch.commit();
};

/**
 * Saves Sponsors.
 */
export const saveSponsors = async ({
  demoContext,
  sponsors = [],
} = {}) => {
  const eventId =
    demoContext?.eventResult?.eventId;

  if (!eventId || sponsors.length === 0) {
    return [];
  }

  const batch = writeBatch(db);
  const createdSponsors = [];

  sponsors.forEach((sponsor) => {
    const ref = doc(
      collection(
        db,
        "events",
        eventId,
        "sponsors"
      )
    );

    batch.set(ref, {
      ...sponsor,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      demoSeed: true,
    });

    createdSponsors.push({
      ...sponsor,
      id: ref.id,
    });
  });

  const creatorUid = demoContext?.user?.uid;
  const assignedSponsor =
    createdSponsors.find(
      (sponsor) => String(sponsor.name || "").toLowerCase() === "vanabliss"
    ) || createdSponsors[0];

  if (creatorUid && assignedSponsor?.id) {
    batch.set(
      doc(db, "events", eventId, "users", creatorUid),
      {
        sponsorContact: true,
        sponsorIds: [assignedSponsor.id],
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  }

  await batch.commit();

  return createdSponsors;
};
